import { makeObservable } from 'mobx';
import { createContext, useContext } from 'react';
import { UploadDocumentsModule } from 'store/modules/upload-documents/uploadDocumentsModule';
import UploadDocumentsPageStore, {
  UploadDocumentsDomainData,
} from 'store/modules/upload-documents/uploadDocumentsPageStore';
import { UploadStep } from 'types/documentsService';

export default class UploadResponseRFQDocumentsPageStore extends UploadDocumentsPageStore {
  constructor(domainData: UploadDocumentsDomainData) {
    super(domainData, UploadStep.RFQ_PROPOSAL);

    this._uploadDocumentsModule = new UploadDocumentsModule({
      entityId: domainData.entityId,
      affiliatedId: domainData.affiliatedId,
      uploadStep: UploadStep.INITIATE_RFQ,
    });

    makeObservable<UploadResponseRFQDocumentsPageStore>(this, {});
  }
}

const UploadResponseRFQDocumentsPageStoreContext = createContext(
  new UploadResponseRFQDocumentsPageStore({
    entityId: 'stub-entity',
    affiliatedId: 'stub-affiliation',
  }),
);

export const useUploadResponseRFQDocumentsPageStore = (): UploadResponseRFQDocumentsPageStore => {
  return useContext(UploadResponseRFQDocumentsPageStoreContext);
};

export { UploadResponseRFQDocumentsPageStoreContext };
